<template>
	<transition name="scroll-y-reverse-transition" v-if="module">
		<v-row v-show="module" class="module mb-12 primary pa-sm-12" align="center">
			<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : $vuetify.breakpoint.mdAndUp ? 5 : 6" :order="1" style="position: relative;">
				<div class="d-flex justify-center">
					<div class="module__tag pa-6 accent d-inline-flex" v-if="module.tagTitle && hasImages">
						<h3 class="font--text">{{ module.tagTitle }}</h3>
					</div>
				</div>

				<div class="module__images">
					<v-img
						v-if="module.image"
						:src="imageSrc(module.image)"
						:alt="module.altText"
						lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
						@load="imgIsLoaded = true"
					/>
				</div>
			</v-col>
			<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : $vuetify.breakpoint.mdAndUp ? 7 : 6" :order="1" class="module__text white--text pl-sm-10 pl-7">
				<h2 class="font--text mb-4">{{ module.title }}</h2>
				<p class="mb-12">{{ module.text }}</p>
				<template v-for="link in module.link">
					<v-btn :key="link.caption" color="white" outlined :href="link.link" :target="link.openInNewWindow ? '_blank' : '_self'">{{ link.caption }}</v-btn>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
export default {
	name: 'call-to-action-module',
	props: ['module'],
	data() {
		return {
			imgIsLoaded: false
		};
	},
	methods: {
		imageSrc(test) {
			return test.imageCrops.find(ic => ic.alias == 'Teaser Image').cropUrl;
		}
	},
	computed: {
		hasImage() {
			return !!Object(this.module).image;
		}
	}
};
</script>

<style lang="scss" scoped>
.module {
	&__text {
		h2 {
			font-size: 3rem;
			max-width: 20ch;
			line-height: 1.25;
		}

		p {
			max-width: 40ch;
		}
	}
}
</style>
